// extracted by mini-css-extract-plugin
export var fullHeightState = "_5r-7";
export var headerCell = "_5r-1";
export var loadingStateCell = "_5r-4";
export var rowWrapper = "_5r-3";
export var standaloneTable = "_5r-8";
export var standaloneTableWithBodyFill = "_5r-9";
export var stateCell = "_5r-5";
export var table = "_5r-0";
export var tableBodyFiller = "_5r-6";
export var white = "_5r-2";